import {
  Col,
  Row,
  Space,
  Table,
  Tag,
  Card,
  Button,
  message,
  Spin,
  Input,
  Upload,
  notification,
  Tooltip,
} from "antd";
import { useMemo, useState } from "react";
import {
  ReloadOutlined,
  FilterOutlined,
  ImportOutlined,
  EditOutlined,
  DownSquareOutlined,
  UpSquareOutlined,
} from "@ant-design/icons";
import MotionHoc from "../../../utils/MotionHoc";
import {
  BASE_URL_BEN,
  HEADERS_EXPORT_BEN,
  POST_LIST_ASSET,
} from "../../API/apiUrls";
import * as XLSX from "xlsx";

import axios from "axios";
import dayjs from "dayjs";
import { ThaiRangePicker } from "../../../hook/ThaiDatePicker";
import ImportInvestigate from "./modal/ImportInvestigate";
import EditRelationAssets from "./modal/EditRelationAssets";

const Main = () => {
  const userCompany = localStorage.getItem("COMPANY_ID");
  const [arrayTable, setArrayTable] = useState([]);
  const [dataArr, setDataArr] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tableLength, setTableLength] = useState(0);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [dateSearch, setDateSearch] = useState([]);
  const [searchInput, setSearchInput] = useState(null);
  const [dataRecord, setDataRecord] = useState();
  const [arrow, setArrow] = useState("Show");
  const [dataUpload, setDataUpload] = useState([]);
  const [isModalImport, setIsModalImport] = useState(false);
  const [isModalEdit, setIsModalEdit] = useState(false);
  const [advanceSearch, setAdvanceSearch] = useState(true);
  const toggle = () => setAdvanceSearch((v) => !v);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  // useEffect(() => {
  //   reloadData(true, 40);
  // }, []);

  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") {
      return false;
    }
    if (arrow === "Show") {
      return true;
    }
    return {
      pointAtCenter: true,
    };
  }, [arrow]);

  const loadData = async (value) => {
    console.log("2.loadData");
    setLoading(true);
    const payload = {
      invRoundId: value,
    };

    try {
      await axios
        .post(BASE_URL_BEN + POST_LIST_ASSET, payload, {
          headers: HEADERS_EXPORT_BEN,
        })
        .then(async (res) => {
          console.log("res.data", res.data);
          let i = 1;
          if (res.status === 200) {
            const newData = res?.data.map((item) => ({
              ...item,
              key: i++,
            }));
            filterData(newData);
          } else {
            message.error("ไม่มีข้อมูล");
            setArrayTable([]);
            setDataArr([]);
            console.log("res Role", res.data);
          }
        })
        .catch((err) => {
          console.log("ไม่มีข้อมูล", err); // ถ้ามีข้อผิดพลาดอื่น ๆ ให้แสดงข้อความนี้
          setArrayTable([]);
          setDataArr([]);
        });
    } catch (error) {
      console.error("Error loading data:", error);
      message.error(`ไม่พบข้อมูล: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const filterData = (data) => {
    if (data) {
      console.log("5.filterData");

      const useData = sortByRelationFollow(data);

      setArrayTable(useData);
      setDataArr(useData);
      setTableLength(useData?.length);
    } else {
      console.error("data is not an array or is undefined");
      setTableLength(0);
    }
  };

  function sortByRelationFollow(arr) {
    // 1) แยกเป็นกลุ่มตาม contno (จะได้ไม่ปนข้ามสัญญา)
    const groups = arr.reduce((m, it) => {
      const k = it.contno ?? it.loanId ?? "_";
      (m[k] ??= []).push(it);
      return m;
    }, {});

    const result = [];

    // 2) จัดแต่ละกลุ่ม
    for (const key of Object.keys(groups)) {
      const group = groups[key];

      // followerMap: parentCustomerId -> [followers...]
      const followerMap = new Map();
      for (const it of group) {
        if (it.garno === 0 && it.relationCustomerId != null) {
          const list = followerMap.get(it.relationCustomerId) || [];
          list.push(it); // เก็บตามลำดับเดิม
          followerMap.set(it.relationCustomerId, list);
        }
      }

      // 3) สร้างลำดับใหม่แบบคงความเป็น original order ให้มากที่สุด
      const placed = new Set(); // customerId ที่วางแล้ว

      // ฟังก์ชันช่วย: วางตัวหลัก + ตามด้วยลูก ๆ ที่อ้างถึงเขา
      const placeWithFollowers = (parent) => {
        if (placed.has(parent.customerId)) return;
        result.push(parent);
        placed.add(parent.customerId);

        const followers = followerMap.get(parent.customerId) || [];
        for (const f of followers) {
          if (!placed.has(f.customerId)) {
            result.push(f);
            placed.add(f.customerId);
          }
        }
      };

      // 3.1 วางตัวหลัก (ไม่ใช่ follower ภายในกลุ่ม)
      for (const it of group) {
        const isFollower =
          it.garno === 0 &&
          it.relationCustomerId != null &&
          group.some((x) => x.customerId === it.relationCustomerId);
        if (!isFollower) {
          placeWithFollowers(it);
        }
      }

      // 3.2 วางที่เหลือ (เผื่อกรณี orphan หรือ relation อยู่นอกกลุ่ม)
      for (const it of group) {
        if (!placed.has(it.customerId)) {
          placeWithFollowers(it);
        }
      }
    }

    return result;
  }

  const handlefilterData = () => {
    console.log("handlefilterData");

    setLoading(true);
    setSelectedRowKeys([]);
    setSelectedRows([]);

    // 1) ตั้งต้นจาก data เดิม
    let result = Array.isArray(dataArr) ? [...dataArr] : [];

    // 2) ค้นหาด้วยข้อความ (เลขสัญญา)
    const q = (searchInput ?? "").trim().toLowerCase();
    if (q) {
      result = result.filter((item) =>
        String(item.contno ?? "")
          .toLowerCase()
          .includes(q),
      );
    }

    // 4) กรองช่วงวันที่ (ต้องมี 2 ค่า)
    if (Array.isArray(dateSearch) && dateSearch[0] && dateSearch[1]) {
      const startTs = dayjs(dateSearch[0]).startOf("day").valueOf();
      const endTs = dayjs(dateSearch[1]).endOf("day").valueOf();

      result = result.filter((item) => {
        if (!item.dateCeoInvestigate) return false; // ถ้าไม่มีวันที่ ตัดออก (ปรับตามต้องการ)
        const t = dayjs(item.dateCeoInvestigate).valueOf(); // เวลาเป็นมิลลิวินาที
        return t >= startTs && t <= endTs; // อยู่ในช่วง (รวมปลายทั้งสองข้าง)
      });

      console.log("result", result);
    }

    // 5) ใส่ผลลัพธ์กลับลงตาราง
    setArrayTable(result);
    setTableLength?.(result.length);

    if (result.length === 0) message.info("ไม่พบข้อมูลที่ตรงเงื่อนไข");

    setLoading(false);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (rowKeys, selectedRows) => {
      onSelectChange(rowKeys, selectedRows);
    },
  };

  const onSelectChange = (selectedRowKeys, selectedRows) => {
    setSelectedRowKeys(selectedRowKeys);
    setSelectedRows(selectedRows);
    console.log(selectedRows);
  };

  const reloadData = (status, value) => {
    console.log(value);
    if (status && value) {
      loadData(value);
    }
  };

  // const handleFileUpload = (file) => {
  //   const reader = new FileReader();
  //   reader.onload = (event) => {
  //     const arrayBuffer = event.target.result; // อ่านไฟล์เป็น ArrayBuffer
  //     const workbook = XLSX.read(new Uint8Array(arrayBuffer), {
  //       type: "array",
  //     });
  //     setArrayTable([]);

  //     const allData = [];
  //     let missingFoundData = [];
  //     let hasMissingId;
  //     // วนลูปผ่านทุกชีตในไฟล์
  //     workbook.SheetNames.forEach((sheetName) => {
  //       const sheet = workbook.Sheets[sheetName];
  //       const sheetData = XLSX.utils.sheet_to_json(sheet);

  //       // const filteredData = sheetData
  //       //   .map((row) => ({
  //       //     contno: row["เลขสัญญา"] || "",
  //       //     customerFullname: row["รายชื่อ"] || "",
  //       //     cusCode: row["รหัสบัตร"] ? String(row["รหัสบัตร"]).trim() : "",
  //       //     unFound: row["ไม่พบ"],
  //       //     found: row["พบ"],
  //       //     mark: row["หมายเหตุ"] || "",
  //       //     tr14: row["คัด ทร.14"] || 0,
  //       //     family_registration: row["ทะเบียนครอบครัว"] || 0,
  //       //     operation_fee: row["ดำเนินงาน"] || 0,
  //       //     additional_fee: row["ตรวจเพิ่ม"] || 0,
  //       //     total: row["รวม"] || 0,
  //       //      tr14Excel: row["คัด ทร.14"] || 0,
  //       //     family_registrationExcel: row["ทะเบียนครอบครัว"] || 0,
  //       //     operation_feeExcel: row["ดำเนินงาน"] || 0,
  //       //     additional_feeExcel: row["ตรวจเพิ่ม"] || 0,
  //       //     totalExcel: row["รวม"] || 0,
  //       //     cusId: row["customer_id"],
  //       //     asset_online_id: row["asset_online_id"],
  //       //     inv_id: row["inv_id"] || "",
  //       //     loanId: row["loanId"] || "",
  //       //     roundId: row["roundId"],
  //       //     SCHEMA: row["SCHEMA"],
  //       //     garno: row["garno"],
  //       //   }))
  //       //   // ดักข้อมูล ถ้าไม่มีทั้ง รหัสบัตร และ รายชื่อ ไม่เอา
  //       //   .filter((item) => item.operation_fee);
  //       const JURISTIC_KEYWORDS = [
  //         "บจก.",
  //         "บจ.",
  //         "บมจ.",
  //         "หจก.",
  //         "หสน.",
  //         "บล.",
  //         "บริษัท",
  //         "ห้างหุ้นส่วนจำกัด",
  //         "ห้างหุ้นส่วนสามัญนิติบุคคล",
  //         "นิติบุคคลอาคารชุด",
  //         "นิติบุคคลหมู่บ้านจัดสรร",
  //         "สมาคม",
  //         "มูลนิธิ",
  //       ];

  //       const isJuristic = (name) =>
  //         JURISTIC_KEYWORDS.some((kw) => name?.includes(kw));

  //       const calcFees = (
  //         cusId,
  //         customerFullname,
  //         rawAdditionalFee,
  //         rawOperationFee,
  //       ) => {
  //         //มี customer_id และ ไม่ใช่นิติบุคคล → eligible = true
  //         const eligible = cusId != null && !isJuristic(customerFullname);

  //         const operation_fee = Number(rawOperationFee) > 0 ? 200 : 0;
  //         const additional_fee = Number(rawAdditionalFee) > 0 ? 50 : 0;
  //         const tr14 = eligible && operation_fee > 0 ? 10 : 0;
  //         const family_registration = eligible && operation_fee > 0 ? 20 : 0;
  //         const total =
  //           tr14 + family_registration + operation_fee + additional_fee;

  //         return {
  //           tr14,
  //           family_registration,
  //           operation_fee,
  //           additional_fee,
  //           total,
  //         };
  //       };

  //       const filteredData = sheetData
  //         .map((row) => {
  //           const cusId = row["customer_id"];
  //           const customerFullname = row["รายชื่อ"] || "";
  //           const rawAdditionalFee = row["ตรวจเพิ่ม"] || 0;
  //           const rawOperationFee = row["ดำเนินงาน"] || 0;

  //           // ✅ คำนวณค่าใหม่ตาม logic
  //           const {
  //             tr14,
  //             family_registration,
  //             operation_fee,
  //             additional_fee,
  //             total,
  //           } = calcFees(
  //             cusId,
  //             customerFullname,
  //             rawAdditionalFee,
  //             rawOperationFee,
  //           );

  //           return {
  //             contno: row["เลขสัญญา"] || "",
  //             customerFullname,
  //             cusCode: row["รหัสบัตร"] ? String(row["รหัสบัตร"]).trim() : "",
  //             unFound: row["ไม่พบ"],
  //             found: row["พบ"],
  //             mark: row["หมายเหตุ"] || "",
  //             tr14,
  //             family_registration,
  //             operation_fee,
  //             additional_fee,
  //             total,

  //             tr14Excel: Number(row["คัด ทร.14"]) || 0,
  //             family_registrationExcel: Number(row["ทะเบียนครอบครัว"]) || 0,
  //             operation_feeExcel: Number(row["ดำเนินงาน"]) || 0,
  //             additional_feeExcel: Number(row["ตรวจเพิ่ม"]) || 0,
  //             totalExcel: Number(row["รวม"]) || 0,

  //             cusId,
  //             asset_online_id: row["asset_online_id"],
  //             inv_id: row["inv_id"] || "",
  //             loanId: row["loanId"] || "",
  //             roundId: row["roundId"],
  //             SCHEMA: row["SCHEMA"],
  //             garno: row["garno"],
  //           };
  //         })
  //         .filter((item) => item.customerFullname);

  //       hasMissingId = filteredData.every((item) =>
  //         [item.inv_id, item.asset_online_id, item.loanId, item.roundId].every(
  //           (id) => id === undefined || id === "" || id === null,
  //         ),
  //       );

  //       if (hasMissingId) {
  //         message.error("ฟอร์ม Excel ไม่ถูกต้อง ติดต่อ admin");
  //         return;
  //       }

  //       // ตรวจว่ามีแถวไหนที่ไม่มีค่า 'ไม่พบ' และ 'พบ' หรือไม่
  //       // missingFoundData = filteredData.filter(
  //       //   (item) =>
  //       //     (item.unFound === undefined ||
  //       //       item.unFound === "" ||
  //       //       item.unFound === null) &&
  //       //     (item.found === undefined ||
  //       //       item.found === "" ||
  //       //       item.found === null)
  //       // );
  //       missingFoundData = filteredData.filter(
  //         (item) =>
  //           item.customerFullname === undefined || item.customerFullname === "",
  //       );
  //       console.log("missingFoundData", missingFoundData);

  //       if (missingFoundData.length > 0) {
  //         const missingList = (
  //           <ul style={{ marginLeft: 20 }}>
  //             {missingFoundData.map((d, index) => (
  //               <li key={index}>
  //                 <strong>{d.contno || "-"}</strong> (
  //                 {d.customerFullname || "ไม่ระบุชื่อ"})
  //               </li>
  //             ))}
  //           </ul>
  //         );

  //         notification.error({
  //           message: "พบข้อมูลไม่ครบถ้วน",
  //           description: (
  //             <>
  //               <div>
  //                 แถวต่อไปนี้ไม่มีค่า <b>ชื่อ-สกุล</b>:
  //               </div>
  //               {missingList}
  //             </>
  //           ),
  //           duration: 8,
  //         });
  //       }

  //       console.log("filteredData", filteredData);
  //       allData.push(...filteredData);
  //     });

  //     // ฟังก์ชันแยก contnoGroup จาก contno (เอาแค่ตัวเลข)
  //     const getContnoGroup = (contno) => {
  //       if (!contno || contno.trim() === "") return "";
  //       return contno;
  //     };

  //     // เติม contnoGroup และเติม contno ที่ว่างด้วยค่าจากแถวก่อนหน้า
  //     let lastContnoGroup;
  //     const dataWithContnoGroup = allData.map((item) => {
  //       if (item.contno && item.contno.trim() !== "") {
  //         // ถ้ามี contno ให้สร้าง contnoGroup
  //         lastContnoGroup = getContnoGroup(item.contno);
  //         return {
  //           ...item,
  //           contnoGroup: lastContnoGroup,
  //         };
  //       } else {
  //         // ถ้า contno ว่าง ให้ใช้ contnoGroup จากแถวก่อนหน้า
  //         return {
  //           ...item,
  //           contnoGroup: lastContnoGroup,
  //         };
  //       }
  //     });

  //     console.log("allData", dataWithContnoGroup);

  //     let i = 1;
  //     const newData = dataWithContnoGroup.map((item) => ({
  //       ...item,
  //       key: i++,
  //     }));

  //     if (missingFoundData.length > 0 || hasMissingId) {
  //       return null;
  //     } else {
  //       setDataUpload(newData);
  //       setIsModalImport(true);
  //     }
  //   };

  //   reader.readAsArrayBuffer(file); // อ่านไฟล์เป็น ArrayBuffer
  //   return false; // ป้องกันการอัพโหลดอัตโนมัติ
  // };

  const handleFileUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const arrayBuffer = event.target.result;
      const workbook = XLSX.read(new Uint8Array(arrayBuffer), {
        type: "array",
      });
      setArrayTable([]);

      const allData = [];
      let missingFoundData = [];
      let hasMissingId = false;

      const JURISTIC_KEYWORDS = [
        "บจก.",
        "บจ.",
        "บมจ.",
        "หจก.",
        "หสน.",
        "บล.",
        "บริษัท",
        "ห้างหุ้นส่วนจำกัด",
        "ห้างหุ้นส่วนสามัญนิติบุคคล",
        "นิติบุคคลอาคารชุด",
        "นิติบุคคลหมู่บ้านจัดสรร",
        "สมาคม",
        "มูลนิธิ",
      ];

      const isJuristic = (name) =>
        JURISTIC_KEYWORDS.some((kw) => name?.includes(kw));

      const calcFees = (
        cusId,
        customerFullname,
        rawAdditionalFee,
        rawOperationFee,
      ) => {
        console.log("cusId", cusId);
        console.log("rawAdditionalFee", rawAdditionalFee);

        const eligible = cusId != null && !isJuristic(customerFullname);
        const operation_fee = Number(rawOperationFee) > 0 ? 200 : 0;
        const additional_fee = Number(rawAdditionalFee) || 0;
        const tr14 = eligible && operation_fee > 0 ? 10 : 0;
        const family_registration = eligible && operation_fee > 0 ? 20 : 0;
        const total =
          tr14 + family_registration + operation_fee + additional_fee;

        return {
          tr14,
          family_registration,
          operation_fee,
          additional_fee,
          total,
        };
      };

      workbook.SheetNames.forEach((sheetName) => {
        const sheet = workbook.Sheets[sheetName];
        const sheetData = XLSX.utils.sheet_to_json(sheet);
        let currentNoExcel = "";
        // ── 1. map + filter ──────────────────────────────────
        const filteredData = sheetData
          .map((row) => {
            const cusId = row["customer_id"];
            const customerFullname = row["รายชื่อ"] || "";
            const rawAdditionalFee = row["ตรวจเพิ่ม"] || 0;
            const rawOperationFee = row["ดำเนินงาน"] || 0;
            const count = row["count"];
            if (row["ลำดับ"]) {
              currentNoExcel = row["ลำดับ"];
            }
            const {
              tr14,
              family_registration,
              operation_fee,
              additional_fee,
              total,
            } = calcFees(
              cusId,
              customerFullname,
              rawAdditionalFee,
              rawOperationFee,
              count,
            );

            return {
              noExcel: currentNoExcel,
              contno: row["เลขสัญญา"] || "",
              customerFullname,
              cusCode: row["รหัสบัตร"]
                ? String(row["รหัสบัตร"]).replace(/[\s-]/g, "")
                : "",
              unFound: row["ไม่พบ"],
              found: row["พบ"],
              mark: row["หมายเหตุ"] || "",
              tr14,
              family_registration,
              operation_fee,
              additional_fee,
              total,
              tr14Excel: Number(row["คัด ทร.14"]) || 0,
              family_registrationExcel: Number(row["ทะเบียนครอบครัว"]) || 0,
              operation_feeExcel: Number(row["ดำเนินงาน"]) || 0,
              additional_feeExcel: Number(row["ตรวจเพิ่ม"]) || 0,
              totalExcel: Number(row["รวม"]) || 0,
              cusId,
              asset_online_id: row["asset_online_id"],
              inv_id: row["inv_id"] || "",
              loanId: row["loanId"] || "",
              roundId: row["roundId"],
              SCHEMA: row["SCHEMA"],
              garno: row["garno"],
              count: row["count"],
            };
          })
          .filter((item) => item.customerFullname);

        // ── 2. ตรวจ format Excel ─────────────────────────────
        hasMissingId = filteredData.every((item) =>
          [
            item.inv_id,
            item.asset_online_id,
            item.loanId,
            item.roundId,
          ].every((id) => id === undefined || id === "" || id === null),
        );

        if (hasMissingId) {
          message.error("ฟอร์ม Excel ไม่ถูกต้อง ติดต่อ admin");
          return;
        }

        // ── 3. ตรวจแถวไม่มีชื่อ ──────────────────────────────
        missingFoundData = filteredData.filter(
          (item) => !item.customerFullname,
        );

        if (missingFoundData.length > 0) {
          notification.error({
            message: "พบข้อมูลไม่ครบถ้วน",
            description: (
              <>
                <div>
                  แถวต่อไปนี้ไม่มีค่า <b>ชื่อ-สกุล</b>:
                </div>
                <ul style={{ marginLeft: 20 }}>
                  {missingFoundData.map((d, i) => (
                    <li key={i}>
                      <strong>{d.contno || "-"}</strong> (
                      {d.customerFullname || "ไม่ระบุชื่อ"})
                    </li>
                  ))}
                </ul>
              </>
            ),
            duration: 8,
          });
        }

        allData.push(...filteredData);
      });

      // ── 4. เติม contnoGroup ──────────────────────────────────
      let lastContnoGroup;
      const dataWithContnoGroup = allData.map((item) => {
        const contno = String(item.contno ?? "").trim();
        if (contno) {
          lastContnoGroup = contno;
        }
        return { ...item, contnoGroup: lastContnoGroup };
      });

      // ── 5. dedup ผู้เช่าซื้อ (cusCode) ข้ามสัญญา แต่แยกตามบทบาท
      // และตามผู้เช่าซื้อหลักของกลุ่ม (contno มีค่า = เป็นผู้เช่าซื้อหลักของ
      // contnoGroup นั้น, ว่าง = ผู้ค้ำ/คู่สมรสของผู้เช่าซื้อหลักคนนั้น) ─────
      // คนคนเดียวกันจะถูก dedup (fee = 0) ก็ต่อเมื่อบทบาทตรงกันและอยู่ภายใต้
      // ผู้เช่าซื้อหลักคนเดียวกันเท่านั้น ถ้าผู้เช่าซื้อหลักคนละคน ถือว่าคนละ
      // กรณี ต้องได้รับค่าธรรมเนียมทั้งคู่
      const primaryCusCodeByGroup = {};
      dataWithContnoGroup.forEach((item) => {
        if (item.contno && item.cusCode) {
          primaryCusCodeByGroup[item.contnoGroup] = item.cusCode;
        }
      });

      const seenKey = new Set();
      const dedupedData = dataWithContnoGroup.map((item) => {
        const key = item.contno
          ? `${item.cusCode || `name__${item.customerFullname}`}__lessee`
          : `${item.cusCode || `name__${item.customerFullname}`}__other__${
              primaryCusCodeByGroup[item.contnoGroup] || ""
            }`;
        if (seenKey.has(key)) {
          return {
            ...item,
            tr14: 0,
            family_registration: 0,
            operation_fee: 0,
            additional_fee: 0,
            total: 0,
          };
        }
        seenKey.add(key);
        return item;
      });

      // ── 6. ตรวจ cusCode ซ้ำภายใน contno เดียวกัน ────────────
      const cusCodeCountByContno = {};
      dedupedData.forEach((item) => {
        if (!item.cusCode || !item.contnoGroup) return;
        const contnoKey = item.contnoGroup;
        if (!cusCodeCountByContno[contnoKey]) {
          cusCodeCountByContno[contnoKey] = {};
        }
        cusCodeCountByContno[contnoKey][item.cusCode] =
          (cusCodeCountByContno[contnoKey][item.cusCode] || 0) + 1;
      });

      const duplicateCusCodeData = [];
      Object.entries(cusCodeCountByContno).forEach(
        ([contnoGroup, cusCodeCounts]) => {
          Object.entries(cusCodeCounts).forEach(([cusCode, count]) => {
            if (count > 1) {
              duplicateCusCodeData.push({ contnoGroup, cusCode, count });
            }
          });
        },
      );

      if (duplicateCusCodeData.length > 0) {
        notification.error({
          message: "พบรหัสบัตรซ้ำในสัญญาเดียวกัน",
          description: (
            <>
              <div>
                พบ <b>รหัสบัตร</b> ซ้ำกันภายในเลขสัญญาเดียวกัน:
              </div>
              <ul style={{ marginLeft: 20 }}>
                {duplicateCusCodeData.map((d, i) => (
                  <li key={i}>
                    เลขสัญญา <strong>{d.contnoGroup}</strong> - รหัสบัตร{" "}
                    <strong>{d.cusCode}</strong> ({d.count} รายการ)
                  </li>
                ))}
              </ul>
            </>
          ),
          duration: 8,
        });
      }

      // ── 7. เติม key ──────────────────────────────────────────
      const newData = dedupedData.map((item, i) => ({
        ...item,
        key: i + 1,
      }));

      console.log("newData", newData);

      if (
        missingFoundData.length > 0 ||
        hasMissingId ||
        duplicateCusCodeData.length > 0
      ) {
        return null;
      } else {
        setDataUpload(newData);
        setIsModalImport(true);
      }
    };

    reader.readAsArrayBuffer(file);
    return false;
  };

  const uploadProps = {
    customRequest: ({ file, onSuccess, fileList }) => {
      handleFileUpload(file);
      if (file.status !== "uploading") {
        console.log(file, fileList);
      } else {
        onSuccess(); // Call onSuccess when the file is handled
      }
    },
    showUploadList: false,
  };

  const columns = [
    {
      title: "ลำดับ",
      dataIndex: "key",
      key: "key",
      align: "center",
      width: "10%",
      render: (text, object, key) => key + 1,
    },
    {
      title: "เลขสัญญา",
      dataIndex: "contno",
      key: "contno",
      align: "center",
      render: (text, record) => <>{record.contno}</>,
    },
    {
      title: "ชื่อ-กสุล",
      dataIndex: "dateSend",
      key: "dateSend",
      align: "center",
      render: (text, record) => (
        <>
          {`${record.SNAM}${record.NAME1} ${record.NAME2 ? record.NAME2 : ""}`}
        </>
      ),
    },
    {
      title: "สถานะ",
      align: "center",
      render: (record) => (
        <Tag
          color={
            record.statusActiveInvestigate === 3
              ? "green"
              : record.statusActiveInvestigate === 4
                ? "red"
                : record.statusActiveInvestigate === 2
                  ? "blue"
                  : null
          }
        >
          {record.statusActiveInvestigate === 3
            ? "เจอทรัพย์"
            : record.statusActiveInvestigate === 4
              ? "ไม่เจอทรัพย์"
              : record.statusActiveInvestigate === 2
                ? "รอดำเนินการ"
                : null}
        </Tag>
      ),
    },
    {
      title: "การจัดการ",
      align: "center",
      render: (record) => (
        <Button
          color="blue"
          variant="outlined"
          onClick={() => {
            console.log(record.data);
            setDataRecord(record.data);
            setIsModalEdit(true);
          }}
        >
          <EditOutlined />
          แก้ไข
        </Button>
      ),
    },
  ];

  return (
    <>
      <Card>
        <Row>
          <Col span={6} style={{ textAlign: "start" }}>
            <Upload {...uploadProps}>
              <Button
                color="orange"
                variant="outlined"
                style={{ marginRight: "5px" }}
                icon={<ImportOutlined />}
              >
                นำเข้า Excel
              </Button>
            </Upload>
          </Col>
          <Col span={24} style={{ textAlign: "start" }}>
            <Tooltip
              title={advanceSearch ? "ซ่อนตัวกรอง" : "แสดงตัวกรอง"}
              arrow={mergedArrow}
            >
              {!advanceSearch ? (
                <DownSquareOutlined
                  style={{ fontSize: 20, color: "blue", marginTop: 4 }}
                  onClick={toggle} // antd ส่งค่า checked มาให้
                />
              ) : (
                <UpSquareOutlined
                  style={{ fontSize: 20, color: "blue", marginTop: 4 }}
                  onClick={toggle} // antd ส่งค่า checked มาให้
                />
              )}
            </Tooltip>
          </Col>
        </Row>
      </Card>
      <Card>
        <Spin spinning={loading} size="large" tip=" Loading... ">
          <Row>
            {advanceSearch ? (
              <Col
                span={24}
                style={{ textAlign: "start", marginBottom: "10px" }}
              >
                <Space size={10} wrap>
                  <ThaiRangePicker
                    value={dateSearch}
                    onChange={setDateSearch}
                    size="large"
                  />
                  <Input
                    placeholder="ค้นหาสัญญา"
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                    style={{ width: "100%", borderRadius: 8 }}
                    size="small"
                    suffix={<span style={{ marginRight: 5 }}>👤</span>}
                  />
                  <Button
                    icon={<FilterOutlined />}
                    size="large"
                    style={{
                      borderRadius: 8,
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                      fontWeight: "bold",
                      backgroundColor: "#fff7d6",
                      color: "#333",
                      border: "1px solid #ffe58f",
                    }}
                    onClick={() => handlefilterData()}
                    disabled={dataArr.length === 0}
                  >
                    กรองข้อมูล
                  </Button>
                  <Button
                    icon={<ReloadOutlined />}
                    onClick={() => {
                      setDateSearch(null);
                      setSearchInput(null);
                      setSelectedRowKeys([]);
                      setSelectedRows([]);
                    }}
                    color="red"
                    variant="outlined"
                    disabled={dataArr.length === 0}
                  >
                    ล้าง
                  </Button>
                </Space>
              </Col>
            ) : null}
            <Col span={"24"}>
              <Table
                size="small"
                columns={columns}
                dataSource={arrayTable}
                scroll={{ x: 850 }}
                // rowSelection={rowSelection}
                footer={() => (
                  <div
                    style={{
                      alignItems: "center",
                    }}
                  >
                    <p style={{ margin: 0 }}>จำนวนสัญญาทั้งหมด {tableLength}</p>
                  </div>
                )}
              />
            </Col>
          </Row>
        </Spin>
      </Card>
      {isModalImport ? (
        <ImportInvestigate
          open={isModalImport}
          close={setIsModalImport}
          dataDefault={dataUpload}
          func={reloadData}
        />
      ) : null}
      {isModalEdit ? (
        <EditRelationAssets
          open={isModalEdit}
          close={setIsModalEdit}
          data={dataRecord}
          func={reloadData}
          namePage={"import"}
        />
      ) : null}
    </>
  );
};

const ImportInvestigateAssestsOnline = MotionHoc(Main);
export default ImportInvestigateAssestsOnline;
